/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
  Box,
  makeStyles,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { setTechModelAction } from "../../redux/techModel.js";
import Button from "../../components/Button";
import { setUserData } from "../../redux/user";
import { dismiss, setDismissAction } from "../../redux/dismiss";
import "./deactivation-form.scss";
import { ReactComponent as ChevronDownIcon } from "../../img/caret.svg";
import api from "../../api";
import { setErrorMessage } from "../../redux/errors";
import { mapErrorMessage } from "../../utils";

const env = process.env.REACT_APP_ENV != "prod" ? false : true;

const useStyles = makeStyles((theme) => ({
  container: {
    borderTop: "2px solid #cfdae2",
    position: "relative",
    marginTop: 8,
    marginBottom: 16,
    [theme.breakpoints.up("md")]: {
      marginBottom: 0,
      marginTop: 30,
    },
  },
  title: {
    fontSize: "16px",
    color: "#004987",
    margin: "-20px",
    padding: "0 10px",
    backgroundColor: "#fff",
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
    },
  },
  legendIcon: {
    backgroundColor: "white",
    width: 38,
    height: 38,
    border: "2px solid lightgrey",
    borderRadius: "50%",
    display: "none",
    justifyContent: "center",
    alignItems: "center",
    color: "lightgrey",
    position: "absolute",
    right: 30,
    top: -19,
    [theme.breakpoints.up("sm")]: {
      display: "flex",
    },
  },
  label: {
    fontSize: "20px",
    color: "#717271",
    top: "-15px",
  },
  labelSmall: {
    fontSize: "20px",
    color: "#717271",
    top: "-15px",
    [theme.breakpoints.up("lg")]: {
      alignSelf: "flex-end",
    },
  },
  phoneLabel: {
    fontSize: "20px",
    color: "#717271",
    top: "-15px",
    width: "370px",
    textAlign: "left",
    [theme.breakpoints.up("sm")]: {
      width: "603px",
    },
    [theme.breakpoints.up("md")]: {
      width: "500px",
    },
    [theme.breakpoints.up("lg")]: {
      width: "566px",
    },
  },
  formControl: {
    marginTop: "24px",
    padding: "0",
    flex: 1,
    marginRight: "20px",
  },
  input: {
    color: "#323232",
    fontSize: "16px",
  },
  inputSmall: {
    color: "#323232",
    fontSize: "16px",
  },
  checkboxHelperText: {
    fontWeight: "bold",
    fontSize: "10px",
    fontStyle: "italic",
    color: "#323232",
  },
  checkboxFormControl: {
    marginTop: "18px",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    paddingLeft: "20px",
  },
  selectIcon: {
    position: "absolute",
    left: "95%",
    top: "5px",
    zIndex: "-1000",
  },
  checkbox: {
    marginLeft: "30px",
  },
  error: {
    color: "#FF0000",
  },
}));

let validationSchema;

export default function DeactivationForm(props, title, children) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const [acceptTerms, setAcceptTerms] = useState(false);
  const [validationErrors, setValidationErrors] = useState();
  const [remaining, setRemaining] = useState(10);
  const [disabled, setDisabled] = useState(false);

  const { policyNumber, productDesc } = props.insuranceData.insuranceToDisable;

  const { contactDetails, token, user } = useSelector(({ user, auth }) => ({
    user: user,
    contactDetails: user.contactDetails,
    token: auth.token,
  }));

  const { email } = contactDetails || {};

  const companies = ["Movistar", "Personal", "Tuenti", "Nextel", "Claro"];

  const initialValues = {
    email: email ? email : "",
    phone: "",
    phoneCompany: "",
    areaCode: "",
  };

  validationSchema = Yup.object({
    email: Yup.string()
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        {
          message: "Email inválido",
        }
      )
      .required("Campo obligatorio"),
    phoneCompany: Yup.string().required("Campo obligatorio"),
    areaCode: Yup.string().required("Campo obligatorio"),
    phone: Yup.string().required("Campo obligatorio"),
  });

  const { values, errors, touched, setFieldValue, isSubmitting, validateForm } =
    useFormik({
      enableReinitialize: true,
      initialValues,
      validationSchema,
    });

  function handleBlur() {
    setValidationErrors("");
  }

  function handleChange(e) {
    setValidationErrors("");
    const key = e.target.name;
    const value = e.target.value;
    const phoneRegExp = /^[0-9]*$/;

    if (key === "phone" || key === "areaCode") {
      if (value.match(phoneRegExp)) {
        setFieldValue(key, value);
        if (key === "areaCode") {
          setRemaining(10 - value.length);
        }
      } else {
        setValidationErrors(key);
      }
    } else {
      setFieldValue(key, value);
    }
  }

  const firstRender = useRef(true);

  async function handleSubmit() {
    if (values.email) {
      dispatch(
        setUserData({
          contactDetails: { email: values.email },
        })
      );
    }

    const data = {
      insurance: {
        policyNumber,
        productId: productDesc,
      },
      customer: {
        name: `${user.nombre} ${user.apellido}`,
        residenceCode: "80",
        contactCellphone: {
          areaCode: values.areaCode,
          phoneNumber: values.phone,
          smsProvider: values.phoneCompany,
        },
        electronicsContact: {
          emailAddressComplete: email ? email : values.email,
        },
        validIntegration: JSON.stringify(acceptTerms),
      },
      newContact: {
        contactPhone: {
          areaCode: values.areaCode,
          phoneNumber: values.phone,
          smsProvider: values.phoneCompany,
        },
        electronicsContact: {
          emailAddressComplete: values.email ? values.email : email,
        },
      },
    };

    setDisabled(true);

    try {
      const response = await api.delete(`/seguros/env/${env}/ch/PDS`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data,
      });
      setDisabled(false);
      dispatch(setDismissAction(response));
      history.push(`/baja`);
    } catch (error) {
      dispatch(setErrorMessage(mapErrorMessage("systemError")));
      history.push(`/error`);
    }
  }

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    async function validateForm() {
      const a = await handleSubmit();
    }
    if (!isSubmitting) {
      validateForm();
    }
  }, []);

  const hasError = (input) => (errors[input] && touched[input] ? true : false);

  async function handleClick() {
    const showErrors = await validateForm();

    if (Object.keys(showErrors).length == 0) {
      const submitting = await handleSubmit();
    }
  }

  return (
    <>
      <Box classes={{ root: classes.container }}>
        <Box classes={{ root: classes.legendIcon }}>
          <img
            src={require("../../img/pencil.svg")}
            alt=''
            style={{ width: "50%" }}
          />
        </Box>
        <Box display='flex' justifyContent='center' mt='8px'>
          <Box
            classes={{ root: classes.title }}
            component='h3'
            fontWeight='fontWeightBold'
          >
            Completá los siguientes datos{" "}
          </Box>
        </Box>
        <Box width='90%' mx='auto' mb='24px'>
          <form
            onSubmit={handleSubmit}
            noValidate
            autoComplete='off'
            className='model-form-container'
          >
            <FormControl classes={{ root: classes.formControl }}>
              <InputLabel
                shrink
                focused={false}
                htmlFor='mail'
                classes={{ root: classes.label }}
              >
                Mail
              </InputLabel>
              <Input
                id='email'
                name='email'
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                error={hasError("email")}
                classes={{ root: classes.input }}
              />
              <FormHelperText
                classes={{ root: classes.error }}
                error={hasError("email")}
              >
                {errors.email && errors.email}
              </FormHelperText>
            </FormControl>
            <FormControl classes={{ root: classes.formControl }}>
              <InputLabel
                shrink
                focused={false}
                htmlFor='area'
                classes={{ root: classes.labelSmall }}
              >
                Código de área
              </InputLabel>
              <Input
                id='areaCode'
                name='areaCode'
                value={values.areaCode}
                onChange={handleChange}
                onBlur={handleBlur}
                error={hasError("areaCode")}
                classes={{ root: classes.inputSmall }}
                inputProps={{
                  maxLength: 5,
                }}
              />
              <FormHelperText
                classes={{ root: classes.error }}
                error={hasError("areaCode")}
              >
                {errors.areaCode &&
                  validationErrors !== "areaCode" &&
                  errors.areaCode}
                {validationErrors === "areaCode" && "número inválido"}
              </FormHelperText>
            </FormControl>
            <FormControl classes={{ root: classes.formControl }}>
              <InputLabel
                shrink
                focused={false}
                htmlFor='phone'
                classes={{ root: classes.phoneLabel }}
              >
                Celular{" "}
                <span className='legend'>
                  (ingresá tu número sin el 0 y sin
                  <br /> el 15)
                </span>
              </InputLabel>
              <Input
                id='phone'
                name='phone'
                value={values.phone}
                onChange={handleChange}
                onBlur={handleBlur}
                error={hasError("phone")}
                classes={{ root: classes.input }}
                inputProps={{
                  maxLength: remaining,
                }}
              />
              <FormHelperText
                classes={{ root: classes.error }}
                error={hasError("phone")}
              >
                {errors.phone && errors.phone}
              </FormHelperText>
            </FormControl>
          </form>
        </Box>

        <Box>
          <form
            onSubmit={handleSubmit}
            noValidate
            autoComplete='off'
            className='model-form-container'
          >
            <FormControl classes={{ root: classes.formControl }}>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={() => setAcceptTerms(!acceptTerms)}
                    id='terms'
                    name='terms'
                    color='primary'
                    classes={{ root: classes.checkbox }}
                  />
                }
                labelPlacement='end'
                classes={{ label: classes.checkboxHelperText }}
                label='Quiero actualizar mis datos en la base del banco'
              />
              <span className='message'>
                El e-mail ingresado será utilizado para enviarte avisos y
                novedades de Patagonia e-bank
              </span>
            </FormControl>
            <FormControl fullWidth classes={{ root: classes.formControl }}>
              <InputLabel
                shrink
                focused={false}
                htmlFor='email'
                classes={{ root: classes.label }}
              >
                Compañia telefónica
              </InputLabel>
              <Select
                id='phoneCompany'
                name='phoneCompany'
                value={values.phoneCompany}
                onChange={handleChange}
                onBlur={handleBlur}
                error={hasError("phoneCompany")}
                IconComponent={() => (
                  <ChevronDownIcon className={classes.selectIcon} />
                )}
              >
                {companies.map((item, key) => {
                  return (
                    <MenuItem key={key} value={item}>
                      {item}
                    </MenuItem>
                  );
                })}
              </Select>
              <FormHelperText
                classes={{ root: classes.error }}
                error={hasError("phoneCompany")}
              >
                {errors.phoneCompany && errors.phoneCompany}
              </FormHelperText>
            </FormControl>
          </form>
        </Box>
      </Box>
      <span className='disclaimer'>
        Te informamos que para revocar la aceptación de tu/s producto/s o
        rescindir la relación contractual con nuestra entidad, prodrás dirigirte
        a cualquiera de nuestras sucursales, por Patagonia e-bank con tu clave
        personal o Atención Telefónica con tu clave personal al teléfono
        0810-888-8500, de lunes a viernes de 9 a 19hs. Cabe destacar que el
        perfeccionamiento de tu solicitud de baja quedará sujeto a la veracidad
        de los datos consignados en ella.
      </span>
      <div className='button-container'>
        <Button color='primary' onClick={() => props.closeModal(false)}>
          Volver
        </Button>
        <Button
          color={disabled ? "#A8A8A8" : "secondary"}
          onClick={() => handleClick()}
          disabled={disabled}
        >
          Continuar
        </Button>
      </div>
    </>
  );
}
